import React, { useState, useEffect } from 'react';
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Platform,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { JobCardFormWrapper } from '../../components/forms/JobCardFormWrapper';
import { JobCard } from '../../types';
import { useMaintenanceStore } from '../../stores/maintenanceStore';
import { useJobCardContext } from '../../contexts/JobCardContext';
import { useNavigationContext } from '../../navigation/NavigationContext';
import theme from '../../theme';

export const MaintenanceDetailsScreen = ({ navigation, route }: any) => {
  const isWeb = Platform.OS === 'web';
  const { selectedJobCardId } = useJobCardContext();
  const { setCurrentRoute } = useNavigationContext();
  const jobCardId = isWeb ? selectedJobCardId : route?.params?.jobCardId || null;
  const { jobCards } = useMaintenanceStore();
  const [jobCard, setJobCard] = useState<JobCard | null>(null);

  useEffect(() => {
    if (!jobCardId) {
      console.warn('No jobCardId provided to MaintenanceDetailsScreen');
      return;
    }
    const card = jobCards.find(j => j.id === jobCardId);
    if (card) {
      setJobCard(card);
    }
  }, [jobCardId, jobCards]);

  if (!jobCardId) {
    return (
      <View style={styles.container}>
        <View style={styles.centered}>
          <Ionicons name="document-text-outline" size={64} color={theme.colors.textSecondary} />
          <Text style={styles.message}>No job card selected.</Text>
          <Text style={styles.submessage}>Please select a job card to view.</Text>
        </View>
      </View>
    );
  }

  if (!jobCard) {
    return (
      <View style={styles.container}>
        <View style={styles.centered}>
          <Ionicons name="document-text-outline" size={64} color={theme.colors.textSecondary} />
          <Text style={styles.message}>Job card not found.</Text>
          <Text style={styles.submessage}>The job card you're looking for doesn't exist.</Text>
        </View>
      </View>
    );
  }

  const handleGoBack = () => {
    if (isWeb) {
      setCurrentRoute('MaintenanceJobCards');
    } else {
      navigation?.goBack?.();
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={handleGoBack} style={styles.backButton}>
          <Ionicons name="arrow-back" size={24} color="#007AFF" />
          <Text style={styles.backText}>Back to List</Text>
        </TouchableOpacity>
      </View>
      <JobCardFormWrapper 
        mode="view"
        existingJobCard={jobCard}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  backText: {
    fontSize: 16,
    color: '#007AFF',
    fontWeight: '500',
  },
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.xl,
  },
  message: {
    fontSize: theme.typography.sizes.lg,
    color: theme.colors.textPrimary,
    marginTop: theme.spacing.md,
    textAlign: 'center',
  },
  submessage: {
    fontSize: theme.typography.sizes.sm,
    color: theme.colors.textSecondary,
    marginTop: theme.spacing.sm,
    textAlign: 'center',
  },
});
